import { supabase } from "@/integrations/supabase/client";

type AdminEvent = "signup" | "assessment_completed" | "blueprint_generated" | "purchase";

interface NotifyArgs {
  eventType: AdminEvent;
  userName?: string | null;
  userEmail?: string | null;
  occurredAt?: string | null;
  idempotencyKey: string;
  details?: Record<string, string | number | null | undefined>;
}

/**
 * Fire-and-forget admin notification. Never throws and never blocks
 * the calling UI flow - server-side delivery has its own retry/queue.
 */
export const notifyAdmin = async ({
  eventType,
  userName,
  userEmail,
  occurredAt,
  idempotencyKey,
  details,
}: NotifyArgs): Promise<void> => {
  try {
    await supabase.functions.invoke("notify-admin", {
      body: {
        eventType,
        userName: userName ?? undefined,
        userEmail: userEmail ?? undefined,
        occurredAt: occurredAt ?? undefined,
        idempotencyKey,
        details: details ?? {},
      },
    });
  } catch (e) {
    console.warn("notifyAdmin failed", e);
  }
};
